export const types = {
  // Layout
  CHANGE_SIDEBAR_TYPE: '[LAYOUT] CHANGE_SIDEBAR_TYPE',
  // Auth
  AUTH_SET: '[AUTH] AUTH_SET',
  AUTH_UNSET: '[AUTH] AUTH_UNSET',
  AUTH_CHECKING: '[AUTH] AUTH_CHECKING',
  // Products
  PRODUCT_START: '[PRODUCT] PRODUCT_START',
  PRODUCT_SUCCESS: '[PRODUCT] PRODUCT_SUCCESS',
  PRODUCT_FAIL: '[PRODUCT] PRODUCT_FAIL',
  // Purchases
  PURCHASE_START: '[PURCHASE] PURCHASE_START',
  PURCHASE_SUCCESS: '[PURCHASE] PURCHASE_SUCCESS',
  PURCHASE_FAIL: '[PURCHASE] PURCHASE_FAIL',
  // Branches
  BRANCHES_START: '[BRANCHES] BRANCHES_START',
  BRANCHES_SUCCESS: '[BRANCHES] BRANCHES_SUCCESS',
  BRANCHES_FAIL: '[BRANCHES] BRANCHES_FAIL',
  // Sales
  SALES_START: '[SALES] SALES_START',
  SALES_SUCCESS: '[SALES] SALES_SUCCESS',
  SALES_FAIL: '[SALES] SALES_FAIL',
  // User
  USER_START: '[USER] USER_START',
  USER_SUCCESS: '[USER] USER_SUCCESS',
  USER_FAIL: '[USER] USER_FAIL',
};
